"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Icon = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = require("@JohnLewisPartnership/jl-design-system/dist/components/icon/ALPHA/Icon");
var _SvgIcon = _interopRequireDefault(require("./SvgIcon/SvgIcon"));
var _iconModule = _interopRequireDefault(require("./icon.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Icon = exports.Icon = function Icon(_ref) {
  var name = _ref.name,
    className = _ref.className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? 'outlined' : _ref$style,
    ariaLabel = _ref.ariaLabel,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'heritage-green' : _ref$color;
  var isJlmIcon = name === null || name === void 0 ? void 0 : name.startsWith('jlm');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: isJlmIcon ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SvgIcon["default"], {
      name: name,
      color: color,
      className: className
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ALPHA_Icon, {
      name: name.toLowerCase(),
      className: (0, _classnames["default"])(_iconModule["default"].icon, className),
      style: style,
      ariaLabel: ariaLabel,
      size: size,
      onError: function onError() {}
    })
  });
};
var _default = exports["default"] = Icon;